import { ConfigProvider } from "antd";
import type { ReactNode } from "react";

/** 关闭 Ant Design 的双汉字自动空格，保持 Vue/Element Plus 的原始按钮文案与宽度。 */
export function LegacyUiProvider({ children }: { children: ReactNode }) {
    return <ConfigProvider
        button={{ autoInsertSpace: false }}
        theme={{
            token: {
                borderRadius: 4,
                colorBorder: "#dcdfe6",
                colorPrimary: "#1966ff",
                colorText: "#303133",
                colorTextPlaceholder: "#a8abb2",
                controlHeight: 32,
                fontFamily: '"PingFang SC", "Microsoft YaHei", sans-serif',
                fontSize: 14
            },
            components: {
                Button: {
                    borderRadius: 4,
                    controlHeight: 32,
                    fontWeight: 500,
                    paddingInline: 15,
                    primaryColor: "#fff"
                },
                DatePicker: {
                    activeBorderColor: "#1966ff",
                    controlHeight: 34,
                    hoverBorderColor: "#c0c4cc"
                },
                Input: {
                    activeBorderColor: "#1966ff",
                    hoverBorderColor: "#c0c4cc"
                },
                InputNumber: {
                    activeBorderColor: "#1966ff",
                    hoverBorderColor: "#c0c4cc"
                },
                Select: {
                    activeBorderColor: "#1966ff",
                    controlHeight: 34,
                    hoverBorderColor: "#c0c4cc",
                    optionSelectedBg: "#eaf1ff"
                },
                Table: {
                    headerBg: "#eaf1ff",
                    headerColor: "#626d83"
                }
            }
        }}
    >{children}</ConfigProvider>;
}
